import Vue from 'vue';

const VUE_APP_AUTH_BASE_URL = process.env.VUE_APP_AUTH_BASE_URL;

export const sendForgotPasswordRequest = (payload) => {
  return Vue.axios.put(`${VUE_APP_AUTH_BASE_URL}/user/send-forgot-password`, payload);
};
